import './branch-overview.scss';
import BranchOverview from './branch-overview';

export default BranchOverview;
